import { render, staticRenderFns } from "./SectionSidebar.vue?vue&type=template&id=659f3f19&"
import script from "./SectionSidebar.vue?vue&type=script&lang=js&"
export * from "./SectionSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports